import styled from "styled-components";

const ProductsQTY = styled.div`

h5{
    width: 100%;
    text-align: right;
    font-size: .8rem;
    padding-right: 2rem;
    font-family: 'roboto';
}
`

export default ProductsQTY